import React from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import ProfileBox from '../profile-box/profile-box';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import Icon from '../icon/icon';
import Spinner from '../spinner/spinner';
import { submitForm } from '../../lib/form';
import { CONTACT_ROUTE, GET_ASSISTANCE_ROUTE, LOG_IN_ROUTE } from '../../constants/constants';

class Account extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			loaded: false,
			lesseeFirstName: '',
			lesseeLastName: '',
			accountNo: '',
			vehicles: []
		};
	}

	componentDidMount () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			this.props.setRoute(LOG_IN_ROUTE);
		} else {
			this.props.setParentState({
				progressIndex: 0,
				canLogOut: false,
				canGoToHomePage: false
			});

			this.setState({
				loaded: true,
				lesseeFirstName: this.props.inspectionRequest.lesseeFirstName,
				lesseeLastName: this.props.inspectionRequest.lesseeLastName,
				accountNo: this.props.inspectionRequest.accountNo,
				vehicles: this.props.inspectionRequest.vehicles
			});
		}
	}

	render () {
		// Dispite changing the route in componentDidMount React will attempt to render this
		// at least once, so we're doing this to avoid a crash
		if (_.isEmpty(this.props.inspectionRequest)) {
			return (<div />);
		}

		const __ = mergeI18n(this.props.language, i18n);
		const formSubmit = submitForm(true, () => this.props.setRoute(CONTACT_ROUTE));
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		if (!this.state.loaded) {
			return (<Spinner />);
		}

		const profileData = {
			title: __.myProfile,
			line1: {
				display: [this.state.lesseeFirstName, this.state.lesseeLastName].join(' '),
				id: 'lesseeName'
			},
			line2: {
				display: `${__.accountNo}: ${this.state.accountNo}`,
				id: 'accountNo'
			}
		};

		let {
			year, make, model, vin
		} = this.state.vehicles[0];
		const vehicleData = {
			title: __.myVehicle,
			line1: {
				display: [year, make, model].join(' '),
				id: 'vehicleYmm'
			},
			line2: {
				display: `VIN: ${vin}`,
				id: 'vehicleVin'
			}
		};

		return (
			<div id='lss-content' className='container'>
				<div className='row'>
					<div className='col-xs-12'>
						<div id='account'>
							<form onSubmit={formSubmit}>
								<h1 id='welcomeMessage'>{__.welcomeMessage}</h1>
								<h2>{__.verifyAccountInfo}</h2>
								<div className='row profile-boxes'>
									<div className='col-xs-12 col-sm-6'>
										<ProfileBox {...profileData} />
									</div>
									<div className='col-xs-12 col-sm-6'>
										<ProfileBox {...vehicleData} />
									</div>
								</div>

								<div className='flex-button-spacer' />
								<div className='form-buttons-wrapper'>
									<div className='form-buttons'>
										<button id='data-is-bad' className='btn btn-default' type='button' onClick={() => this.props.setRoute(GET_ASSISTANCE_ROUTE)}>{__.dataIsBad}</button>
										<button id='data-is-good' className='btn btn-primary' type='submit'>{__.dataIsGood} <Icon name='MdChevronRight' /></button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Account.propTypes = {
	inspectionRequest: propTypes.shape({
		lesseeFirstName: propTypes.string,
		lesseeLastName: propTypes.string,
		lesseeEmail: propTypes.string,
		vehicles: propTypes.arrayOf(propTypes.shape({
			vin: propTypes.string.isRequired,
			make: propTypes.string,
			model: propTypes.string,
			year: propTypes.string
		}))
	}),
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Account;
